/*eslint-disable*/
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { rootAPI } from '../config/api';
import { basicAuth } from '../config/auth';

export const useAppData = (appId) => {
  const [app, setApp] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchUserAppData = useCallback(async () => {
    if (!appId) return;

    setLoading(true);
    try {
      const response = await axios.get(`${rootAPI}/api/basic/v2.0.0/apps/details/${appId}`, {
        headers: {
          Authorization: `Basic ${basicAuth}`,
        },
      });
      setApp(response.data.data || {});
    } catch (error) {
      console.error('Failed to fetch app data:', error);
    } finally {
      setLoading(false);
    }
  }, [appId]);

  useEffect(() => {
    fetchUserAppData();
  }, [appId, fetchUserAppData]);

  return { app, appLoading: loading };
};
